import script from "./MillionUsers.vue?vue&type=script&setup=true&lang=ts"
export * from "./MillionUsers.vue?vue&type=script&setup=true&lang=ts"

import "./MillionUsers.vue?vue&type=style&index=0&id=f2e85432&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2e85432"]])

export default __exports__